import { redirect } from "@tanstack/react-router";
import { fetchMyAccess } from "@/hooks/use-my-access";
import { authClient } from "./auth-client";
import { accessKeys, queryClient } from "./query";

export async function requireAuth() {
  const session = await authClient.getSession();
  if (!session.data) throw redirect({ to: "/login" });
  return session.data;
}

export async function requireAdmin() {
  const session = await requireAuth();
  if (session.user.role !== "admin") throw redirect({ to: "/dashboard" });
  return session;
}

/**
 * Company-wide boards (the home summary, Client Partners, Technology, Bench,
 * Internal Time) are refused to Aggregate users by the engine. Send them to
 * their own accounts instead of to a page that can only say no.
 */
export async function requireFullAccess() {
  const session = await requireAuth();
  const access = await queryClient.ensureQueryData({
    queryKey: accessKeys.me(session.user.id),
    queryFn: fetchMyAccess,
  });
  if (access.isAggregate) throw redirect({ to: "/dashboard/accounts" });
}
